import { AutoComplete, Breadcrumb, Input, message, Pagination, Space, Tabs } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  BackIcon,
  CloseIconSearch,
  DelivLogo,
  OrderLogo,
  ReviewLogo,
  SearchIcon,
} from "../../../../asset";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import MapsRoute from "../../../../component/maps/MapsRoute";
import { ROUTES } from "../../../../constant/routeConstant";

import style from "./AllTripAdd.module.css";
import Geocode from "react-geocode";
import _, { update } from "lodash";
import { GROLOG_ORDER_URL, GROLOG_URL } from "../../../../constant/apiConstant";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomTable from "../../../../component/table/CustomTable";
import CustomPaging from "../../../../component/pagination/pagination";
import { detail } from "../../../../service/master/DeliveryAssociateServices";
import { onChanged } from "../../../../util/Util";
import ModalSuccessAdd from "../../../../component/modal/ModalSuccessAdd";
import ModalFailedDelete from "../../../../component/modal/ModalFailedDelete";
import ModalDetail from "../../../../component/modal/ModalDetail";
import MapsSingle from "../../../../component/maps/MapsSingle";
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";

const EditAllTrip = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [pageDeliv, setPageDeliv] = useState(1);
  const [form, setForm] = useState({});
  const [directions, setDirections] = useState([]);
  const [filter, setFilter] = useState("");
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchRecommendation, setSearchRecommedation] = useState();
  const [listRecommendation, setListRecommendation] = useState([]);
  const [searchRecommendation2, setSearchRecommedation2] = useState();
  const [listRecommendation2, setListRecommendation2] = useState([]);
  const [detail, setDetail] = useState([]);
  const [initiate, setInitiate] = useState([]);
  const [limit, setLimit] = useState(10);
  const [initiates, setInitiates] = useState([]);
  const [delivAso, setDelivAso] = useState([]);
  const [listDeliv, setListDeliv] = useState([]);
  const [list, setList] = useState([]);
  const [filter2, setFilter2] = useState("");
  const [messages, setMessages]= useState("")
  const [successModalOpen, setSuccessModalOpen]= useState(false)
  const [failedModalOpen,setFailedModalOpen]= useState(false)
  const [showConfirm, setShowConfirm]=useState(false)
  const [change, setChange] = useState(false);
  const [openDetail, setOpenDetail] = useState(false)
  const [detailId,setDetailId]=useState()
  const [details,setDetails] = useState([])
  const [detailDepot, setDetailDepot] = useState([])
  const dispatch = useDispatch()
  const [loadMaps,setLoadMaps] = useState(false)
  const [pageMap, setPageMap] = useState(1);
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  const location = useLocation();
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const api = GROLOG_ORDER_URL;
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };
  const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const fetchData = async (data, pages) => {
    let id = 1;
    let tkn = token;
    let resDet = await doGet(`/all-trip/${location?.state}?${param}`, tkn);
    setDetail(resDet?.data?.payload?.data);
    setDelivAso(resDet?.data?.payload?.data?.review)
    let listSelect = [];
    resDet?.data?.payload?.data?.order?.trip_route?.map((el) => {
      listSelect.push({
        address: el?.location,
        longitude: Number(el?.longitude),
        latitude: Number(el?.latitude),
        order_id: el?.order_id,
        order_number: el?.order_number,
        status: el?.order_status,
        trip_id:el?.trip_route_id ? el.trip_route_id : 0
      });
    });
    setCards(listSelect);
    let resDepot = await doGets(
      `/depot-configuration/${resDet?.data?.payload?.data?.order?.depot_id}?${param}`,
      token
    );
    setDetailDepot(resDepot?.data?.payload?.data);
    
    let res = await doGet(
      `/order/list-for-all-trip?page=${pages ? pages : page}&limit=${1000}&filter=depot_id eq ${
        resDet?.data?.payload?.data?.order?.depot_id
      }, delivery_associate_id eq ${
        resDet?.data?.payload?.data?.delivery_associate?.delivery_associate_id
      }${
        filter
          ? ", order_number lk " + filter
          : data
          ? ", order_number lk " + data
          : ""
      }&${param}`,
      token
    );
    let init = await doGet(
      `/order/list-for-all-trip/initiate?page=${
        pages ? pages : page
      }&limit=${1000}&filter=depot_id eq ${
        resDet?.data?.payload?.data?.order?.depot_id
      }, delivery_associate_id eq ${
        resDet?.data?.payload?.data?.delivery_associate?.delivery_associate_id
      }${
        filter
          ? ", order_number lk " + filter
          : data
          ? ", order_number lk " + data
          : ""
      }&${param}`,
      token
    );
    setInitiate(init?.data?.payload?.data);
    let datas = [];
    const idSet1 = new Set(res?.data?.payload?.data.map((obj) => obj.order_id));
    const idSet2 = new Set(
      resDet?.data?.payload?.data?.order?.trip_route?.map((obj) => obj.order_id)
    );

    const intersection = [...idSet1].filter((order_id) => idSet2.has(order_id));
    console.log("inter", intersection);
    if (intersection.length > 0) {
      const isIDInArray = (order_id) => {
        return intersection.includes(order_id);
      };

      // Iterate over the arrayOfObjects and splice objects with matching IDs
      for (let i = res?.data?.payload?.data.length - 1; i >= 0; i--) {
        const obj = res?.data?.payload?.data[i];
        if (isIDInArray(obj.order_id)) {
          res?.data?.payload?.data.splice(i, 1);
        }
      }

      res?.data?.payload?.data?.map((el) => {
        datas.push({
          address: el?.address,
          longitude: Number(el?.longitude),
          latitude: Number(el?.latitude),
          order_id: el?.order_id,
          order_number: el?.order_number,
          status: el?.status,
        });
      });
      setList(datas);
    }
    res?.data?.payload?.data?.map((el, i) => {
      datas.push({
        address: el?.address,
        longitude: Number(el?.longitude),
        latitude: Number(el?.latitude),
        order_id: el?.order_id,
        order_number: el?.order_number,
        status: el?.status,
        customer_name: el?.customer_name,
      });
    });
    setList(datas);

    //delivery associate
    let result = await doGets(
      `/delivery-associate?page=${
        pages ? pages : pageDeliv
      }&limit=${limit}&order=id asc&filter=depot_id eq ${
        detail?.order?.depot_id
      }&${param}`,
      token
    );
    let inits = await doGets(
      `/delivery-associate/initiate?page=${
        pages ? pages : pageDeliv
      }&limit=${limit}&order=id asc&filter=depot_id eq ${
        detail?.order?.depot_id
      }&${param}`,
      token
    );
    setListDeliv(result?.data?.payload?.data);
    setInitiates(inits?.data?.payload?.data);
    directionToMaps(pageMap);
  };

  // console.log("listdeliv", listDeliv);

  useEffect(() => {
    fetchData();
    
  }, [filter, pageDeliv]);

  useEffect(()=>{
if (cards.length !== 0 && window.google && detailDepot) {
      directionToMaps(pageMap);
    }
    // if(window.google){
    //   directionToMaps(pageMap);
    // }
  },[cards, window.google, detailDepot])

  const results = [];
  const chunkSize = 25;
  const tempArray = [...cards];
  // let way = [];
  let waypts = [];
  let way = [];
  const directionsService = new window.google.maps.DirectionsService();

  cards?.map((el, i) => {
    way.push({
      location: new window.google.maps.LatLng(el?.latitude, el?.longitude),
      stopover: true,
    });
  });

  while (way.length) {
    results.push(way.splice(0, chunkSize));
  }

  let card = [];
  while (tempArray.length) {
    card.push(tempArray.splice(0, chunkSize));
  }

  const directionToMaps = (pg) => {
    setLoading(true);
    Geocode.setApiKey("AIzaSyC3m-M8TJAIH96lzjN2gDXHpyO1A2tTbsk");
    let way = [];
    cards?.map((el, i) => {
      way.push({
        location: new window.google.maps.LatLng(el?.latitude, el?.longitude),
        stopover: true,
      });
    });
    let resu = [];
    console.log("pesss", waypts);
    const directionsService = new window.google.maps.DirectionsService();
    // const directionsRenderer = new window.google.maps.DirectionsRenderer();

    // const originIcon = {
    //   url: 'https://gromart.blob.core.windows.net/gromatedisk/icon.png', // Replace with the path to your custom origin icon
    //   scaledSize: new window.google.maps.Size(50, 50), // Adjust the size of the icon
    // };

    // const origin = {
    //   lat: Number(detailDepot?.depot_profile?.depot_latitude),
    //   lng: Number(detailDepot?.depot_profile?.depot_longitude),
    // };
    // const destination = {
    //   lat: cards[cards?.length - 1]?.latitude,
    //   lng: cards[cards?.length - 1]?.longitude,
    // };
    console.log("waypts", pg);
    directionsService.route(
      {
        origin:
          pg === 1
            ? {
                lat: Number(detailDepot?.depot_profile?.depot_latitude),
                lng: Number(detailDepot?.depot_profile?.depot_longitude),
              }
            : {
                lat: Number(card[pg - 2][card[pg - 2]?.length - 1].latitude),
                lng: Number(card[pg - 2][card[pg - 2]?.length - 1].longitude),
              },
        destination:
          card.length >= 1
            ? {
                lat: card[pg - 1][card[pg - 1]?.length - 1]?.latitude,
                lng: card[pg - 1][card[pg - 1]?.length - 1]?.longitude,
              }
            : {
                lat: cards[cards?.length - 1]?.latitude,
                lng: cards[cards?.length - 1]?.longitude,
              },

        waypoints: results[pg - 1],
        optimizeWaypoints: true,
        travelMode: window.google.maps.TravelMode.DRIVING,
        // avoidHighways:true,
      },
      (result, status) => {
        if(result?.status === "ZERO_RESULTS"){
          console.log("berhasil kesini");
          setLoadMaps(true)
                  }
                  else if (status === window.google.maps.DirectionsStatus.OK) {
                    setDirections(result);
                    console.log("sini", result);
                    console.log("berhasil kesini 2");
                  }
                }
    );
    setLoading(false);
  };

  const draggingItem = useRef();
  const dragOverItem = useRef();
  const handleDragStart = (e, position) => {
    draggingItem.current = position;
  };

  const handleDragEnter = (e, position) => {
    dragOverItem.current = position;
    const listCopy = [...cards];
    const draggingItemContent = listCopy[draggingItem.current];
    listCopy.splice(draggingItem.current, 1);
    listCopy.splice(dragOverItem.current, 0, draggingItemContent);

    draggingItem.current = dragOverItem.current;
    dragOverItem.current = null;
    setCards(listCopy);
    directionToMaps(pageMap);
  };

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const api = GROLOG_ORDER_URL;
    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const joinCard = async (el, i) => {
    onChanged(dispatch, true); setChange(true)
    // setLoading(true);
    let card = cards?.map((els) => els?.order_id)
    let sub = {
      depot_id: detail?.order?.depot_id,
      delivery_associate_id: detail?.delivery_associate?.delivery_associate_id,
      trip_id: detail?.order?.trip_id,
      list_order: [...card, el?.order_id],
    };
    try {
      let res = await doPost(
        `/all-trip/order-trip/review?${param}`,
        token,
        sub
      );
      // setSuccessModalOpen(true);
      setDelivAso(res?.data?.payload?.data)
      // message.success(_.startCase(res.data.payload.message));
       let newDetail = [...list];
    newDetail.splice(i, 1);
    setCards([...cards, el]);
    setList(newDetail);
    let getLngth = [...cards, el];
    setPageMap(
      getLngth?.length <= 25
        ? 1
        : getLngth?.length <= 50 && getLngth?.length > 25
        ? 2
        : getLngth?.length <= 75 && newDetail.length > 50
        ? 3
        : 4
    )
    directionToMaps(getLngth?.length <= 25
      ? 1
      : getLngth?.length <= 50 && getLngth?.length > 25
      ? 2
      : getLngth?.length <= 75 && newDetail.length > 50
      ? 3
      : 4);
      // setPage(2);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message)
        setFailedModalOpen(true)
      }
    }
    // let newDetail = [...list];
    // newDetail.splice(i, 1);
    // setCards([...cards, el]);
    // setList(newDetail);
    // directionToMaps(pageMap);
    // setLoading(false);
  };
  console.log("card", cards);
  console.log("list", list);

  const removeCard = (el, i) => {
    onChanged(dispatch, true); setChange(true)
    setLoading(true);
    setList([...list, el]);
    let newDetail = [...cards];
    let idx = cards.findIndex((item) => item.order_id === el?.order_id);
    newDetail.splice(idx, 1);
    setCards(newDetail);
    let getLngth = newDetail;
    if(i===cards?.length-1){
      setLoadMaps(false)
    }
    setPageMap(
      getLngth?.length <= 25
        ? 1
        : getLngth?.length <= 50 && getLngth?.length > 25
        ? 2
        : getLngth?.length <= 75 && newDetail.length > 50
        ? 3
        : 4
    );
    directionToMaps(getLngth?.length <= 25
      ? 1
      : getLngth?.length <= 50 && getLngth?.length > 25
      ? 2
      : getLngth?.length <= 75 && newDetail.length > 50
      ? 3
      : 4);
    setLoading(false);
  };

  const onSearchRecommendation = async (value) => {
    setSearchRecommedation(value);
    // setIsfilter(true)
    if (value) {
      setSearchRecommedation(value);
      await fetchRecommendation(1, 10, value);
    } else {
    }
  };

  const onSearchRecommendation2 = async (value) => {
    setSearchRecommedation2(value);
    // setIsfilter(true)
    if (value) {
      setSearchRecommedation2(value);
      await fetchRecommendation2(value);
    } else {
    }
  };

  const onSelectRecommendation = (data) => {
    setPage(1);
    setFilter(data);
    fetchData(data, 1);
    // setIsfilter(false)
    setListRecommendation("");
  };

  const onSelectRecommendation2 = (data) => {
    // fetchData2(data, 1);
    // setIsfilter(false)
    setFilter2(data);
    setListRecommendation2("");
  };

  const onClearRecommendation = (e) => {
    // setIsfilter(false);
    setFilter(null);
    setInitiate([]);
    setSearchRecommedation("");
    setListRecommendation("");
    fetchData("", 1);
  };

  const onClearRecommendation2 = (e) => {
    // setIsfilter(false);
    setFilter2("");
    setSearchRecommedation2("");
    setListRecommendation2("");
    // fetchData("", 1);
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    if (filters.length >= 1) {
      let res = await doGet(
        `/order/list-for-all-trip/search?page=1&limit=10&filter=depot_id eq ${detail?.order?.depot_id}, delivery_associate_id eq ${
          detail?.delivery_associate?.delivery_associate_id
        }, order_number lk ${filters}`,
        token
      );
      setListRecommendation(res?.data?.payload?.data);
    }
  };

  const fetchRecommendation2 = (filters) => {
    console.log("fil", filters);
    if (filters.length >= 1) {
      const filteredObjects = cards.filter((obj) =>
        obj.customer_name.toLowerCase().startsWith(filters.toLowerCase())
      );
      setListRecommendation2(filteredObjects);
    }
  };

  const cardSelect = (el, index) => {
    return (
      <>
        <div
          onDragStart={(e) => handleDragStart(e, index)}
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={(e) => handleDragEnter(e, index)}
          key={index}
          draggable
          className="max-w-[716px] border-2 rounded-md bg-white-100 border-gray-200 h-[100px] mt-2 cursor-move"
        >
          <div className="flex justify-between items-center">
            <div className="w-[85%] flex">
              <div className="w-[10%] justify-center mt-7 ml-3 font-roboto font-medium">
                {el?.order_id}
              </div>
              <div className="w-[90%] mt-3">
                <div className="flex">
                  <div className="font-roboto-medium text-lg text-[#818181]">
                    {el.order_number}
                  </div>
                  <div
                    className={`${
                      el?.status === "New" ? "bg-red-100" : "bg-[#5A005A]"
                    } px-2 rounded-3xl w-auto ml-3`}
                  >
                    <p className=" font-roboto-medium text-lg font-normal text-white-100">
                      {el?.status}
                    </p>
                  </div>
                </div>
                <div className="font-font-roboto-medium text-lg">
                  {el.address}
                </div>
              </div>
            </div>
            <div className="w-15%">
              <div className="mt-3 ml-10">
                <img
                  src={CloseIconSearch}
                  alt="close"
                  onClick={() => removeCard(el, index)}
                />
              </div>
              <div onClick={()=>setModal(el?.order_id, el.trip_id ? el.trip_id :0)} className="mt-2 mr-2 font-roboto font-normal text-sm text-red-100">
                view detail
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const setModal = async(orderId, tripId) =>{
    if(tripId !== 0){
      let res = await doGet(`/all-trip/trip-route/${tripId}?${param}`, token);
    setDetails(res?.data?.payload?.data);
    }else{
      let res = await doGet(`/order/${orderId}?${param}`, token);
      setDetails(res?.data?.payload?.data);
    }
    setOpenDetail(true)
  }
  const handlePaginationMap = (a, b) => {
    if (a && b) {
      setPageMap(a);

      directionToMaps(a);
      // setLimitMap(b);
    } else {
    }
  };
  const page1 = () => {
    return (
      <>
        <div>
          <div className="flex mt-3">
            {/* line one */}
            <div className="gap-[40px] mb-[24px]">
              <div className="w-[500px] mb-[24px]">
                <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                  {t("Order Detail")}
                </h3>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("Trip Name")}
                </label>
                <Input
                  className="mt-[8px] h-[47px] w-[500px] ml-2"
                  value={detail?.order?.trip_name}
                  disabled
                  // onChange={(value) => handleChange(value, "depot_name")}
                />
              </div>

              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("Trip Number")}
                </label>
                <Input
                  className="mt-[8px] h-[47px] w-[500px] ml-2"
                  value={detail?.order?.trip_number}
                  disabled
                  // onChange={(value) =>
                  //   handleChange(value, "depot_description")
                  // }
                />
              </div>
            </div>
            {/* line two */}

            <div className="gap-[40px] mb-[24px] ml-32 mt-14">
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("Trip ID")}
                </label>
                <Input
                  className="mt-[8px] h-[47px] w-[500px] ml-2"
                  disabled
                  value={detail?.order?.trip_id}
                  // onChange={(value) => handleChange(value, "depot_name")}
                />
              </div>
            </div>
          </div>
          <div className="w-full ml-[20px]">
          {
              cards.length === 0 ?
              <MapsSingle
              long={Number(detailDepot?.depot_profile?.depot_longitude)}
              lat ={Number(detailDepot?.depot_profile?.depot_latitude)}
              trip={true}/>
              :
              <>
                <MapsRoute
                  data={cards}
                  datas={card[pageMap - 1]}
                  directions={directions}
                  paging={pageMap}
                  // directions1={directions1}
                  // directions2={directions2}
                  // directions3={directions3}
                  long={
                    pageMap === 1
                      ? Number(detailDepot?.depot_profile?.depot_longitude)
                      : Number(
                          card[pageMap - 2][card[pageMap - 2]?.length - 1]
                            .longitude
                        )
                  }
                  lat={
                    pageMap === 1
                      ? Number(detailDepot?.depot_profile?.depot_latitude)
                      : Number(
                          card[pageMap - 2][card[pageMap - 2]?.length - 1]
                            .latitude
                        )
                  }
                />
                <div
                  id={"pageMap"}
                  className={style.Wrap + " justify-end flex"}
                >
                  <div className="font-semibold text-base text-[#1D1D1D]">
                    {card[pageMap - 1].length} Of {cards.length} Order
                  </div>
                  <Pagination
                    onShowSizeChange={false}
                    // {...props}

                    size="small"
                    current={pageMap}
                    defaultCurrent={pageMap}
                    pageSize={25}
                    total={cards?.length}
                    // pageSizeOptions={initiate && initiate?.valid_limit}
                    // onShowSizeChange={() => handlePaginationMap()}
                    onChange={(value) => handlePaginationMap(value, 25)}
                  />
                </div>
                
              </>
            }
          </div>
          {/* drag and drop */}
          <div className="flex">
            <div className="ml-4 mt-2">
              <div className="w-[500px] mb-[24px] ">
                <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                  {t("List Order")}
                </h3>
              </div>
              <div
                className={
                  style.headerContainer + " flex justify-between items-center"
                }
              >
                <div className="flex h-[47px] w-[500px]">
                  <AutoComplete
                    options={
                      listRecommendation &&
                      listRecommendation?.map((item) => ({
                        value: item.value,
                        label: item.value,
                      }))
                    }
                    value={searchRecommendation}
                    onChange={(value) => onSearchRecommendation(value)}
                    onSelect={(value) => onSelectRecommendation(value)}
                  >
                    <Input
                      placeholder={t("Search Trip Id or Name")}
                      suffix={
                        <img
                          src={filter ? CloseIconSearch : SearchIcon}
                          alt="search"
                          onClick={
                            filter ? () => onClearRecommendation() : null
                          }
                        />
                      }
                      // value={searchRecommendation}
                      width={500}
                      className="w-[500x] h-[47px]"
                    />
                  </AutoComplete>
                </div>
              </div>
              {/* cards */}
              <div
                id="scrollableDiv"
                style={{
                  height: "50vh",
                  overflow: "auto",
                  // padding: "0 12px",
                  // marginLeft: -12,
                }}
                // onScroll={(e) => this.onScrollProduct(e)}
              >
                {list?.map((el, index) => {
                  return (
                    <>
                      <div
                        className="max-w-[716px] border-2 shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)] rounded-md bg-white-100 border-gray-200 h-[100px] mt-2 cursor-pointer"
                      >
                        <div className="flex justify-between items-center">
                        <div
                            className={loadMaps ? "w-[85%] flex cursor-not-allowed" :"w-[85%] flex cursor-pointer"}
                            onClick={loadMaps ? "":() => joinCard(el, index)}
                          >
                            <div className="w-[10%] justify-center mt-7 ml-3 font-roboto font-medium">
                              {el?.order_id}
                            </div>
                            <div className="w-[90%] mt-3">
                              <div className="flex">
                                <div className="font-roboto-medium text-lg text-[#818181]">
                                  {el.order_number}
                                </div>
                                <div
                                  className={`${
                                    el?.status === "New"
                                      ? "bg-red-100"
                                      : "bg-[#5A005A]"
                                  } px-2 rounded-3xl w-auto ml-3`}
                                >
                                  <p className=" font-roboto-medium text-lg font-normal text-white-100">
                                    {el?.status}
                                  </p>
                                </div>
                              </div>
                              <div className="font-font-roboto-medium text-lg">
                                {el.address}
                              </div>
                            </div>
                          </div>
                          <div className="w-[15%]">
                            <div className="mt-3"></div>
                            <div onClick={()=>setModal(el?.order_id,0)} className=" font-roboto font-normal text-sm text-red-100">
                              view detail
                            </div>
                          </div>
                        </div>
                        {/* tes {el?.trip_route_id}
                        {el?.address} */}
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
            <div className="ml-10 mt-2">
              <div className="w-[500px] mb-[24px] ">
                <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                  {t("List Selected")}
                </h3>
              </div>
              <div
                className={
                  style.headerContainer + " flex justify-between items-center"
                }
              >
                <div className="flex h-[47px] ">
                  <AutoComplete
                    // options={options}
                    options={
                      listRecommendation2 &&
                      listRecommendation2?.map((item) => ({
                        value: item.customer_name,
                        label: item.customer_name,
                      }))
                    }
                    value={searchRecommendation2}
                    onChange={(value) => onSearchRecommendation2(value)}
                    onSelect={(value) => onSelectRecommendation2(value)}
                    //  allowClear={true}
                  >
                    <Input
                      placeholder={t("Search Trip Id or Name")}
                      suffix={
                        <img
                          src={filter2 ? CloseIconSearch : SearchIcon}
                          alt="search"
                          onClick={
                            filter2 ? () => onClearRecommendation2() : null
                          }
                        />
                      }
                      // value={searchRecommendation}
                      width={500}
                      className="max-w-[500px] h-[47px]"
                    />
                  </AutoComplete>
                </div>
              </div>
              {/* cards */}
              <div
                id="scrollableDiv"
                style={{
                  height: "50vh",
                  overflow: "auto",
                  // padding: "0 12px",
                  // marginLeft: -12,
                }}
                // onScroll={(e) => this.onScrollProduct(e)}
              >
                {filter2 !== ""
                  ? cards
                      .filter((obj) =>
                        obj.customer_name
                          .toLowerCase()
                          .startsWith(filter2.toLowerCase())
                      )
                      .map((el, index) => {
                        return <>{cardSelect(el, index)}</>;
                      })
                  : cards?.map((el, index) => {
                      return <>{cardSelect(el, index)}</>;
                    })}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const page2 = () => {
    return <>
    <div className="flex ml-10 mt-5">
          <div>
            <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
              {t("Driver Information")}
            </h3>
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Delivery Associate ID")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={detail?.delivery_associate?.delivery_associate_id}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Driver ID")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={detail?.delivery_associate?.driver_id}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Driver Name")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={detail?.delivery_associate?.driver_name}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Driver Phone")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={detail?.delivery_associate?.phone}
                    disabled
                  />
                </div>
                </div>
                </div>
                </div>
                <div className="ml-20">
            <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
              {t("Vehicle Information")}
            </h3>
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Vehicle Model")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={detail?.delivery_associate?.vehicle_model}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("License Plate")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={detail?.delivery_associate?.license_plate}
                    disabled
                  />
                </div>
                </div>
                </div>
                </div>
                </div>
                
    </>;
  };
  const page3 = () => {
    return (
      <>
        <div className="flex ml-10 mt-5">
          <div>
            <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
              {t("Trip Detail")}
            </h3>
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Order")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={delivAso.total_order}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Left Capacity Weight")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.left_capacity_weight}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="Kg"
                      disabled
                    />
                  </Space.Compact>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Left Capacity Volume")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.left_capacity_volume}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="M2"
                      disabled
                    />
                  </Space.Compact>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Left Capacity Unit")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={delivAso.left_capacity_unit}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Trip Distance")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.total_trip_distance}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="Km"
                      disabled
                    />
                  </Space.Compact>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Cost")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="IDR"
                      disabled
                    />
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.total_cost}
                    />
                  </Space.Compact>
                </div>
              </div>
              {/* Line two */}
              <div className="gap-[40px] mb-[24px] ml-20">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Customer")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={delivAso.total_customer}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Weight of Trip")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.total_weight_of_trip}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="Kg"
                      disabled
                    />
                  </Space.Compact>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Volume of Trip")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.total_volume_of_trip}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="M2"
                      disabled
                    />
                  </Space.Compact>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Unit of Trip")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={delivAso.total_unit_of_trip}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Estimation Time")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.total_estimation_time}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="Min"
                      disabled
                    />
                  </Space.Compact>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = GROLOG_ORDER_URL + endpoint;
    const method = "PUT";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };


  const onSubmit = async() => {
    let card = cards?.map((els) => els?.order_id)
    let sub = {
      depot_id: detail?.order?.depot_id,
      delivery_associate_id: detail?.delivery_associate?.delivery_associate_id,
      list_order: [...card],
      updated_at:detail?.updated_at
    };
    try {
      let res = await doPut(
        `/all-trip/order-trip/${location.state}?${param}`,
        token,
        sub
      );
      // setSuccessModalOpen(true);
      setSuccessModalOpen(true)
      // message.success(_.startCase(res.data.payload.message));
      // setPage(2);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        setMessages(err.response.data.payload.message)
        setFailedModalOpen(true)
        // message.error(_.startCase(err.response.data.payload.message));
      }
    }
  };

  const items = [
    {
      key: 1,
      label: t("Order"),
      children: page1(),
    },
    {
      key: 2,
      label: t("Delivery Associate"),
      children: page2(),
    },
    {
      key: 3,
      label: t("Review"),
      children: page3(),
    },
  ];
  const actModalSuccess = () => {
    setSuccessModalOpen(false);
    navigate({
      pathname: ROUTES.ALL_TRIP.LIST,
    });
    
  };
  const actModal = () => {
    setSuccessModalOpen(false);
    setFailedModalOpen(false)
    setMessages("")
  };
  const onClose =()=>{
    setDetails([])
setDetailId()
setOpenDetail(false)
  }
  return (
    <>
    <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.ALL_TRIP.LIST}
      />
    <ModalDetail
    show={openDetail}
    onClose={()=>onClose()}
    orderId={detailId}
    tripId={0}
    detail={details}/>
    <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModalSuccess()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description={"Your data has been updated"}
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => actModal()}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be added"
        description={messages}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>Order</Breadcrumb.Item>
            <Breadcrumb.Item>Routes</Breadcrumb.Item>
            <Breadcrumb.Item>All Trip</Breadcrumb.Item>
            <Breadcrumb.Item>Edit All Trip</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="flex items-center justify-between">
        <div
            onClick={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.ALL_TRIP.LIST)
            }
            className="flex items-center gap-[22px] cursor-pointer"
          >
            <img src={BackIcon} alt="" className="cursor-pointer" />
            
            <h1 className="font-sans-bold text-[28px]" id="title">
              Edit All Trip
            </h1>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            {/* <img
              src={page === 1 ? OrderLogo : page === 2 ? DelivLogo : ReviewLogo}
              alt="tab"
            /> */}
            <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            />
            {/* {!loading
              ? page === 1
                ? page1()
                : page === 2
                ? page2()
                : page3()
              : "loading..."} */}
          </div>
        </div>

        <div className="flex flex-row-reverse gap-[16px]">
          {/* {page === 1 ? (
            <>
              <PrimaryButton
                text={t("COMMON:NEXT")}
                action={() => onSubmit()}
              />
              <SecondaryButton text={t("USER_DETAIL:CANCEL")} />
            </>
          ) : page === 2 ? (
            <>
              <PrimaryButton
                text={t("COMMON:NEXT")}
                action={() => onSubmit()}
              />
              <SecondaryButton
                text={t("USER_DETAIL:CANCEL")}
                action={() => setPage(1)}
              />
            </>
          ) : ( */}
            <>
              <PrimaryButton
                action={() => onSubmit()}
                text={t("USER_DETAIL:SAVE")}
              />
              <SecondaryButton
                action={
                  change
                    ? () => setShowConfirm(true)
                    : () => navigate(ROUTES.ALL_TRIP.LIST)
                }
                text={t("USER_DETAIL:CANCEL")}
              />
            </>
          {/* )} */}
          {/* <PrimaryButton text={t("COMMON:NEXT")} />
          <SecondaryButton text={t("USER_DETAIL:CANCEL")} /> */}
        </div>
      </div>
    </>
  );
};
export default EditAllTrip;
